import { Button } from '@mui/material';
import { ReactComponent as CrossIcon } from 'assets/icons/cross.svg';
import { UseFieldArrayRemove, UseFormResetField } from 'react-hook-form';

interface DeleteButtonProps {
  rowIndex: number;
  totalRows: number;
  onRemove: UseFieldArrayRemove;
  onReset: UseFormResetField<any>;
}

export default function DeleteButton({
  totalRows,
  rowIndex,
  onReset,
  onRemove,
}: DeleteButtonProps) {
  const handleDeleteCopyFormRow = () => {
    if (totalRows === 1) {
      onReset(`copyForms.${rowIndex}`);
    } else {
      onRemove(rowIndex);
    }
  };

  return (
    <Button onClick={handleDeleteCopyFormRow}>
      <CrossIcon />
    </Button>
  );
}
